import React, { useCallback, memo } from "react";
import styles from "./Toggle.module.css";
import { HapticFeedback } from "../../utils/hapticFeedback";
interface ToggleProps {
  isActive: boolean;
  onClick: () => void;
  theme?: "light" | "dark";
  disabled?: boolean;
}

const ToggleComponent: React.FC<ToggleProps> = ({
  isActive,
  onClick,
  theme = "light",
  disabled = false,
}) => {
  const handleToggle = useCallback(() => {
    HapticFeedback.selectionChanged(); // Специальный отклик для переключений
    onClick();
  }, [onClick]);

  return (
    <button
      className={`${styles.toggle} ${isActive ? styles.active : ""}`}
      onClick={handleToggle}
      disabled={disabled}
      data-theme={theme}
    >
      <div className={styles.toggleSlider}></div>
    </button>
  );
};

// Мемоизируем компонент для предотвращения лишних ре-рендеров
export const Toggle = memo(ToggleComponent);
